import {Component} from "react";
import Glob from "../../../libs/Glob.mjs";
import appLib from "../../../libs/appLib.mjs";
import AppSynthDataIcon from "../../../media/app-images/AppSynthDataIcon.mjs";
import AppPerimeterIcon from "../../../media/app-images/AppPerimeterIcon.mjs";
import TextLabel from "../../../controls/TextLabel/TextLabel.mjs";
import {Button, Form, Input, InputGroup, InputGroupText, Label} from "reactstrap";
import AppFlagTrueIcon from "../../../media/app-images/AppFlagTrueIcon.mjs";
import AppUploadIcon from "../../../media/app-images/AppUploadIcon.mjs";
import AppFlagFalseIcon from "../../../media/app-images/AppFlagFalseIcon.mjs";
import AppTrashIcon from "../../../media/app-images/AppTrashIcon.mjs";
import AppOkIcon from "../../../media/app-images/AppOkIcon.mjs";
import SliderPanel from "../../BaseLayout/SliderPanel.mjs";
import "./SynthUpload.css";
import AppGestionePerimetriIcon from "../../../media/app-images/AppGestionePerimetriIcon.mjs";
import ModalProgress from "../../../controls/ModalProgress/ModalProgress.mjs";

const prefix = "SynthUpload";

const SynthUpload = class extends Component {
	constructor(props) {
		super(props);
		this.state = {
			lang: Glob.getLanguage()
		}
		this.uid = Glob.generateUid(prefix);
		this.upload = this.upload.bind(this);
	}
	componentDidMount() {
		Glob.setStatus('pageTitle', ['Perimeters','Upload synthetic data']);
		Glob.setStatus('pageIcon',<AppPerimeterIcon /> );
		Glob.register('Prefs', ()=>{
			const lang = Glob.getLanguage();
			if ( lang !== this.state.lang ) this.setState({ lang: lang } );
		}, this.uid);
	}
	componentWillUnmount() {
		Glob.deregister(this.uid);
	}

	upload() {
		if ( ! this.state.json ) return;
		this.setState({ loadOver: false, loading: true }, () => {
			let success = true;
			appLib.api('perimetri/set', {perimetro: this.state.json, name: this.state.name, desc: this.state.description} ).then( ()=>{
				this.setState({name: null, description: null, json: null});
			}).catch( e=>{
				success = false;
				console.error( `Error loading: ${this.state.json.name }`, e );
			}).finally( () => {
				this.setState({ loadOver: true, loadSuccess: success }, () => {
					setTimeout( () => {
						if ( success ) {
							Glob.gotoPage('Perimeters');
						} else {
							this.setState({ loading: false });
						}
					}, 2000 );
				});
			});
		});
	}

	render() {
		return (
			<SliderPanel
				icon={<AppSynthDataIcon />}
				title={<TextLabel value={"Upload synthetic data"}/>}
				className={prefix}
			>
				<div className={"panel-content limited"}>
					<div className={"text-center"}>
					{ this.state.lang === 'it' ? (
						<p>
							I dati sintetici sono conferiti tramite un singolo file JSON, con estensione “<code>.json</code>”
						</p>
					) : (
						<p>
							Synthetic data are provided as a single JSON file, with extension “<code>.json</code>”
						</p>
					)}
					</div>
					<Form
						onSubmit={ e => {
							e.preventDefault();
							this.upload();
						}}
					>
						<InputGroup>
							<InputGroupText>
								<Label>JSON:</Label>
							</InputGroupText>
							<InputGroupText className={"flex-grow-1 justify-content-evenly"}>
								<Button
									className={"btn-icon"}
									color={ this.state.json ? "danger" : "primary"}
									onClick={ async ()=> {
										const d = this.state.json ? false : (await Glob.uploadJSON())?.json;
										this.setState({json: d?.psncgen ? d : false});
									}}
								>
									<b>
										<TextLabel value={this.state.json ? "Delete" : "Choose..." } />
									</b>
									<i>
										{ this.state.json ? <AppTrashIcon /> : <AppUploadIcon /> }
									</i>
								</Button>
								<Label>
									{ this.state.json ? <AppFlagTrueIcon style={{height:"var(--icon-size)"}}/> : <AppFlagFalseIcon style={{height:"var(--icon-size)"}} /> }
								</Label>
							</InputGroupText>
						</InputGroup>
						<InputGroup>
							<InputGroupText>
								<Label>
									<TextLabel value={"Name"} />:
								</Label>
							</InputGroupText>
							<Input
								value={this.state.name||""}
								onChange={ e => {
									this.setState({ name: e.target.value });
								}}
							/>
						</InputGroup>
						<InputGroup>
							<InputGroupText>
								<Label>
									<TextLabel value={"Description"} />:
								</Label>
							</InputGroupText>
							<Input
								type={"textarea"}
								value={this.state.description||""}
								onChange={ e => {
									this.setState({ description: e.target.value });
								}}
							/>
						</InputGroup>
					</Form>
					{ (!!this.state.loading) && (
						<ModalProgress
							title={ <><AppSynthDataIcon /> <TextLabel value={"Loading" } /></> }
							success={this.state.loadOver ? this.state.loadSuccess : undefined }
						/>
					)}
				</div>
				<div className={"panel-footer"}>
					<Button
						className={"btn-icon"}
						color="success"
						onClick={ () => { Glob.gotoPage('Perimeters'); } }
						disabled={ !! this.state.loading }
					>
						<i>
							<AppGestionePerimetriIcon />
						</i>
						<b>
							<TextLabel value={"Available perimeters"}/>
						</b>
					</Button>
					<Button
						color={"primary"}
						onClick={this.upload}
						className={"btn-icon"}
						disabled={ this.state.loading || ! this.state.json }
					>
						<b>
							<TextLabel value={"Upload"}/>
						</b>
						<i>
							<AppOkIcon/>
						</i>
					</Button>
				</div>
			</SliderPanel>
		)
	}
}

export default SynthUpload;
